module.exports = __webpack_public_path__ + "static/media/mobile-app-development.8cae0ab7.png";